// jQuery(document).ready(function($) {
//     console.log('heyyyyyy');
//     var contatore = $('.wishlist_products_counter_number');
//     if (contatore.length && contatore.is(':empty')) {
//         contatore.hide();
//     }
// });
